import { Component, OnInit } from '@angular/core';
import { SatDescargaService } from './sat-descarga.service';
import { SatDescargaDocService } from './sat-descarga-doc.service';
import Swal from 'sweetalert2';
import { LoginService } from '../../login/login.service';
declare var $: any;

@Component({
  selector: 'app-sat-descarga-doc',
  templateUrl: './sat-descarga-doc.component.html',
  styleUrls: ['./sat-descarga-doc.component.css'],
  providers: [SatDescargaService, SatDescargaDocService],
  preserveWhitespaces: true
})
export class SatDescargaDocComponent implements OnInit {
  busqueda: any = {};
  totalItems: number;
  p_folio = '';
  p_fechas = '';
  p_tipo = 'e';
  rotate: any;
  rfc: String;
  items: any[] = [];
  cargado: boolean;
  solicitudes: any[] = [{}];
  p_pagina_solicitudes = 0;
  nuevaSolicitud: Solicitud = new Solicitud();
  totalPages = 0;
  page = 0;
  itemsPerPage = 5;
  constructor
    (public loginService: LoginService,
    private satDescargaDocService: SatDescargaDocService,
    private satDescargaService: SatDescargaService) {
    this.busqueda.criteriaSearch = {};
    this.busqueda.itemsPerPage = 30;
    this.busqueda.pageNumber = 0;
    this.rfc = localStorage.getItem('rfc');
  }

  ngOnInit(): void {
    this.htmlConfig();
    const fechaActual = new Date().toISOString().slice(0, 10);
    this.nuevaSolicitud.fecha_ini = fechaActual;
    this.nuevaSolicitud.fecha_fin = fechaActual;
    this.listaArchivosDescargaMasiva();
  }
  setPageModal(page: number) {
    this.page = page;
  }
  htmlConfig() {
    (<HTMLInputElement>document.getElementById('fecha-inicial-emision')).max =
    new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().split('T')[0];
    (<HTMLInputElement>document.getElementById('fecha-final-emision')).max =
    new Date(new Date().getTime() - new Date().getTimezoneOffset() * 60000).toISOString().split('T')[0];
  }

    setPage(page: number) {
      this.p_pagina_solicitudes = page;
    }
  validarFechaSolicitud(): boolean {
    const fecha_ini = new Date(this.nuevaSolicitud.fecha_ini.replace(/(\d{2})-(\d{2})-(\d{4})/, '$2/$1/$3'));
    const fecha_fin = new Date(this.nuevaSolicitud.fecha_fin.replace(/(\d{2})-(\d{2})-(\d{4})/, '$2/$1/$3'));
    let fecha_limite = fecha_ini;
    fecha_limite = new Date(fecha_limite.setDate(fecha_limite.getDate() + 30));
    return ((fecha_fin <= fecha_limite));
  }


  verificarIntervalo(tipo: string) {
    let fecha_ini = new Date(this.nuevaSolicitud.fecha_ini.replace(/(\d{2})-(\d{2})-(\d{4})/, '$2/$1/$3'));
    const fecha_fin = new Date(this.nuevaSolicitud.fecha_fin.replace(/(\d{2})-(\d{2})-(\d{4})/, '$2/$1/$3'));
    if (tipo === 'ini' && (fecha_fin < fecha_ini)) {
      this.nuevaSolicitud.fecha_fin = this.nuevaSolicitud.fecha_ini;
      fecha_ini = fecha_fin;
    }
    if (tipo === 'fin' && (fecha_fin < fecha_ini)) {
      this.nuevaSolicitud.fecha_ini = this.nuevaSolicitud.fecha_fin;
      fecha_ini = fecha_fin;
    }
    let fecha_limite_fin = new Date(this.nuevaSolicitud.fecha_ini.replace(/(\d{2})-(\d{2})-(\d{4})/, '$2/$1/$3'));
    fecha_limite_fin = new Date(fecha_limite_fin.setDate(fecha_limite_fin.getDate() + 30));
    let fecha_limite_ini = new Date(this.nuevaSolicitud.fecha_fin.replace(/(\d{2})-(\d{2})-(\d{4})/, '$2/$1/$3'));
    fecha_limite_ini = new Date(fecha_limite_ini.setDate(fecha_limite_ini.getDate() - 30));
    if (tipo === 'ini' && (fecha_fin > fecha_limite_fin)) {
      this.nuevaSolicitud.fecha_fin = this.formatDate(fecha_limite_fin);

    } else if (tipo === 'fin' && (fecha_ini < fecha_limite_ini)) {
        this.nuevaSolicitud.fecha_ini = this.formatDate(fecha_limite_ini);
    }
  }
  formatDate(date) {
    var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [year, month, day].join('-');
}

   descargarDocumentos(id: number) {
    Swal.fire({
      title: 'TNK Ledger',
      text: `¿Está seguro de realizar la descarga?`,
      showCancelButton: true,
      confirmButtonText: 'Descargar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        this.mostrarMensajeDescarga();
        this.satDescargaService.descargarDocumentos(id).subscribe(
          response => {
            this.cerrarMensajeCarga();
              Swal.fire({
                title: 'TNK Ledger',
                text: response.mensaje,
                showCancelButton: false,
                allowOutsideClick: false,
                confirmButtonText: 'Ok'
              }).then((result1) => {
                if (result1.value) {
                this.listaArchivosDescargaMasiva();
                this.cargarSolicitudes('na');
                }
              }
          );
      }, err => {
            this.cerrarMensajeCarga();
            if (err.error.mensaje == null || '' || undefined) {
              err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
            }
            Swal.fire({
              icon: 'error',
              title: 'TNK Ledger',
              text: err.error.mensaje
            });
            console.log(err);
          }
        );
      }
    }
    );
  }

  crearSolicitud() {
    this.nuevaSolicitud.gral_emp_id = this.loginService.empresa as number;
    this.nuevaSolicitud.gral_usr_id_crea = this.loginService.usuario.id as number;
    this.satDescargaService.post(this.nuevaSolicitud).subscribe(
      response => {
        Swal.fire('TNK Ledger', response.mensaje, 'success');
        this.cargarSolicitudes('na');
      }, err => {
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        });
        console.log(err);
      }
    );
  }
  limpiarBusquedaSolicitudes() {
    this.p_folio = '';
      this.p_fechas = '';
        this.p_tipo = 'e';
    this.cargarSolicitudes('c');
  }
  cargarSolicitudes(estatus: String) {
    this.solicitudes = [];
    this.satDescargaService.getByEmpIdAndEstatus(this.loginService.empresa, estatus,
      this.p_folio != '' ? this.p_folio : 'na',
     this.p_fechas != '' ? this.p_fechas : 'na',
     this.p_tipo != '' ? this.p_tipo : 'na').subscribe(
      response => {
        this.solicitudes = response.contenido;
        this.totalPages = Math.ceil(this.solicitudes.length / this.itemsPerPage);
        if (response.mensaje != '') {
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: response.mensaje
        });
      }
      }, err => {
        $('#listaSolicitudesModal').modal('hide');
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        });
        console.log(err);
      }
    );
  }

  cargarSolicitudesDescargadas() {
    this.solicitudes = [];
    this.satDescargaService.getByEmpCargadoId(this.loginService.empresa).subscribe(
      response => {
        this.solicitudes = response.contenido;
        
        this.totalPages = Math.ceil(this.solicitudes.length / this.itemsPerPage);
      }, err => {
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        });
        console.log(err);
      }
    );
  }

  cargarDocumentos(sat_descarga_id: number) {
    Swal.fire({
      title: 'TNK Ledger',
      text: `¿Está seguro de realizar la carga al administrador de documentos?`,
      showCancelButton: true,
      confirmButtonText: 'Cargar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.value) {
        this.mostrarMensajeDescarga();
        this.satDescargaService.cargarDocumentos(sat_descarga_id, this.loginService.usuario.id).subscribe(
          response => {
            this.cerrarMensajeCarga();
            this.cargarSolicitudesDescargadas();
            this.listaArchivosDescargaMasiva();
            Swal.fire('TNK Ledger', response.mensaje, 'success');
          }, err => {
            if (err.error.mensaje == null || '' || undefined) {
              err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
            }
            this.cerrarMensajeCarga();
            Swal.fire({
              icon: 'error',
              title: 'TNK Ledger',
              text: err.error.mensaje
            });
            console.log(err);
          }
        );
      }
    }
    );
  }

  listaArchivosDescargaMasiva() {
    this.cargado = false;
    this.busqueda.criteriaSearch['gral_emp_id'] = this.loginService.empresa;
    this.satDescargaDocService.catalogo(this.busqueda).subscribe(
      response => {
        this.items = response.contenido.content;
        this.totalItems = response.contenido.totalElements;
      }, err => {
        if (err.error.mensaje == null || '' || undefined) {
          err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
        }
        Swal.fire({
          icon: 'error',
          title: 'TNK Ledger',
          text: err.error.mensaje
        });
        console.log(err);
      });
  }

  cambiarPagina(event: any): void {
    this.busqueda.pageNumber = event.page - 1;
    this.listaArchivosDescargaMasiva();
  }cambiarPaginaSolicitudes(event: any): void {
    this.p_pagina_solicitudes = event.page - 1;
  }
  filtroDeBusqueda(find: any, columnName: any): void {
    this.busqueda.criteriaSearch[columnName] = find;
  }
  sortearPor(columnName: any): void {
    this.busqueda.column = columnName;
    this.busqueda.sort = true;
    this.busqueda.pageNumber = 0;
    switch (this.busqueda.order) {
      case 'desc':
        this.busqueda.order = 'asc';
        break;
      default:
        this.busqueda.order = 'desc';
        break;
    }
    console.log(this.busqueda);
    this.listaArchivosDescargaMasiva();
  }
  buscarEnCatalogo(): void {
    this.busqueda.pageNumber = 0;
    this.listaArchivosDescargaMasiva();
  }
  limpiarBusqueda(): void {
    this.busqueda.criteriaSearch = {};
    this.busqueda.pageNumber = 0;
    this.listaArchivosDescargaMasiva();
  }
  mostrarMensajeDescarga() {
    this.cargado = false;
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Espere mientras finaliza la descarga, este proceso puede que tome unos minutos',
      timerProgressBar: true,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      }
    });
  }
  descargarHistorico(id: number, nombre_archivo: string) {
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Descargando...',
      timerProgressBar: true,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading();
        this.satDescargaService.descargaHistorico(id).subscribe(response => {
            this.cerrarMensajeCarga();
            const a = document.createElement('a');
            a.href = URL.createObjectURL(response);
            a.download = nombre_archivo;
            document.body.appendChild(a);
            a.click();
        }, err => {
          this.cerrarMensajeCarga();
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: err.error.mensaje
          });
          console.log(err);
        });
      }
    });

  }
  mostrarMensajeCarga() {
    this.cargado = false;
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Procesando...',
      timerProgressBar: true,
      allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading();
      }
    });
  }
  cerrarMensajeCarga() {
    this.cargado = true;
    Swal.close();
  }
}
class Solicitud {
  tipo: String = 'e';
  fecha_ini: String;
  fecha_fin: String;
  gral_emp_id: number;
  gral_usr_id_crea: number;
}
